import styled from 'styled-components';

const LinkStyle = styled.div`
  .iconCard {
    display: flex;
    align-items: center;
  }
  .text {
    margin-left: 20px;
  }
`;
export default LinkStyle;
